import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/ico_sorting.svg?url_encode")